import React, { Component } from "react";
import { Button, Typography } from "antd";
import { Link } from "react-router-dom";
import axios from "axios";
import { connect } from "react-redux";

const { Title, Text } = Typography;


class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
    };
    this.recentErrors = new Set(); 
  }

  componentDidMount() {
    window.onerror = (message, source, lineno, colno, error) => {
      const errorKey = error?.message || message;

      if (!this.recentErrors.has(errorKey)) {
        this.recentErrors.add(errorKey);
        setTimeout(() => this.recentErrors.delete(errorKey), 5000); 

        this.setState({
          hasError: true,
          error: error || message,
        });

        const errorInfo = {
          componentStack: "",
        };

        this.componentDidCatch(error || new Error(message), errorInfo);
        return true;
      }
      return false;
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    try {
      const { sharedUserInfo } = this.props;

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies?.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      const stackTrace = errorInfo.componentStack || "";

      const componentNames = stackTrace
        .split("\n")
        .map((line) => line.match(/at (\w+)/))
        .filter(Boolean)
        .map((match) => match[1]);

      const errorLog = {
        error: error.message,
        route: window.location.pathname,
        additionalInfo: {
          component:
            componentNames.length > 0 ? componentNames[0] : "Unknown Component",
        },
      };

      axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/shared/${companyId}/error-log/create`,
        errorLog,
        config
      );
    } catch (e) {
      console.error("Error in boundary:", e);
    }
  }

  componentWillUnmount() {
    window.onerror = null;
    this.recentErrors.clear();
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            width: "100%",
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Title level={1}>Something Went Wrong</Title>
          <div
            style={{
              marginTop: "20px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Text style={{ fontSize: "16px" }}>
              Brace yourself till we get the error fixed.
            </Text>
            <Text style={{ fontSize: "16px" }}>
              Please refresh the page and if error presists please try again
              later.
            </Text>
          </div>
          <Link to="/">
            <Button
              type="primary"
              size="large"
              style={{ marginTop: "20px" }}
              onClick={() => {
                this.setState({ hasError: false });
              }}
            >
              Go to Home
            </Button>
          </Link>
        </div>
      );
    }

    return this.props.children;
  }
}

const mapStateToProps = (state) => ({
  sharedUserInfo: state.sharedLogin.sharedUserInfo,
});

export default connect(mapStateToProps)(ErrorBoundary);
